import { useContext } from 'react'
import { AppContext } from '../../../contextApi/ContextApi';

export default function ProductComponentRibbon({val}) {
    const {accent_color, secondary_color, primary_color} = useContext(AppContext);
    const hasDis = val.hasDiscount;
    const value = val.disValue;
  return (
    <div>
        {hasDis && <div className="onSaleMsg" style={{backgroundColor:accent_color, color:primary_color, border:`0.5px solid ${primary_color}`, textShadow:`1px 1px 1px ${secondary_color}`}}>
            <div className='onSaleMsg_sub_valueOff'>
                <div className='onSaleMsg_disValue'><p>{value}</p><span>%</span></div>
                <div className='onSaleMsg_off'>Off</div>
            </div>
            <div className='onSaleMsg_sub_onSale' dir='rtl'>במבצע!</div>
        </div>}
    </div>
  )
}
